import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const usePerformanceInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [PerformanceInsightData, setPerformanceInsightData] = useState<any[]>([]);

    const onPerformanceDataError = (err: AxiosError<ErrorHttpResponse>) => {
        setPerformanceInsightData([]);
    };

    const onPerformanceDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<PerformanceDataInterface[]>) => {
        setPerformanceInsightData(Array.isArray(data) ? data : []);
    };

    const getPerformanceDataInsight = (urlString: string) => {
        const url: HttpConfig = {
            url: urlString,
            method: 'get',

        };
        request(url, onPerformanceDataSuccess, setLoading, onPerformanceDataError);
    };

    return { getPerformanceDataInsight, loading, PerformanceInsightData };
};

export default usePerformanceInsight;

interface PerformanceDataInterface {
    noOfRatings: number;
    period: string;
    periodEnd: string;
    periodStart: string;
    weightedScore: number;
}
